// extracted by mini-css-extract-plugin
export default {"heading":"Vi-z","list":"Wi-z"};